<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="19"
		height="19"
		viewBox="0 0 19 19"
		fill="none"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M4.56792 4.74997C4.56792 4.42205 4.83375 4.15622 5.16167 4.15622H15.0416C15.3695 4.15622 15.6354 4.42205 15.6354 4.74997V14.63C15.6354 14.9579 15.3695 15.2238 15.0416 15.2238C14.7137 15.2238 14.4479 14.9579 14.4479 14.63V6.18342L5.16985 15.4615C4.93797 15.6934 4.56203 15.6934 4.33016 15.4615C4.09828 15.2296 4.09828 14.8537 4.33015 14.6218L13.6082 5.34372H5.16167C4.83375 5.34372 4.56792 5.07789 4.56792 4.74997Z"
			fill="black"
		/>
	</svg>
</template>
